import { Action } from 'redux';
import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';

export const ADDONS_INSIGHTS_REPORT_GET_START = 'ADDONS_INSIGHTS_REPORT_GET_START';
export const ADDONS_INSIGHTS_REPORT_GET_SUCCESS = 'ADDONS_INSIGHTS_REPORT_GET_SUCCESS';
export const ADDONS_INSIGHTS_REPORT_GET_ERROR = 'ADDONS_INSIGHTS_REPORT_GET_ERROR';

type AddonsInsightsGetStartAction = Action<typeof ADDONS_INSIGHTS_REPORT_GET_START>;

interface AddonsInsightsGetSuccessAction extends Action<typeof ADDONS_INSIGHTS_REPORT_GET_SUCCESS> {
    payload: {
        report: AddonsInsightsReport;
    };
}

type AddonsInsightsGetErrorAction = Action<typeof ADDONS_INSIGHTS_REPORT_GET_ERROR>;

export type AddonsInsightsReportAction =
    | AddonsInsightsGetStartAction
    | AddonsInsightsGetSuccessAction
    | AddonsInsightsGetErrorAction;
